import { alpha } from '@mui/material/styles';

// SETUP COLORS

export const grey = {
  0: '#FFFFFF',
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#DFE3E8',
  400: '#B0BEC5',
  500: '#607D8B',
  600: '#455A64',
  700: '#37474F',
  800: '#263238',
  900: '#1C1C1E',
};

export const primary = {
  lighter: '#C8FAD6',
  light: '#5BE49B',
  main: '#00A76F',
  dark: '#007867',
  darker: '#004B50',
  contrastText: '#FFFFFF',
};

export const secondary = {
  lighter: '#F2D9FF',
  light: '#A855F7',
  main: '#7A3BB9',
  dark: '#4A1C73',
  darker: '#2B0A4B',
  contrastText: '#FFFFFF',
};

export const info = {
  lighter: '#CAFDF5',
  light: '#4CAED9',
  main: '#0077B6',
  dark: '#004C73',
  darker: '#002940',
  contrastText: '#FFFFFF',
};

export const success = {
  lighter: '#D3FCD2',
  light: '#32A852',
  main: '#1E7E34',
  dark: '#155724',
  darker: '#0B3E16',
  contrastText: '#FFFFFF',
};

export const warning = {
  lighter: '#FFF5CC',
  light: '#FFA726',
  main: '#F57C00',
  dark: '#C66900',
  darker: '#8C4600',
  contrastText: grey[900],
};

export const error = {
  lighter: '#FEE2E2',
  light: '#F44336',
  main: '#D32F2F',
  dark: '#B71C1C',
  darker: '#7F0000',
  contrastText: '#FFFFFF',
};

export const common = {
  black: '#000000',
  white: '#FFFFFF',
};

export const action = {
  hover: alpha(grey[700], 0.08),
  selected: alpha(grey[700], 0.16),
  disabled: alpha(grey[600], 0.8),
  disabledBackground: alpha(grey[600], 0.24),
  focus: alpha(grey[600], 0.24),
  hoverOpacity: 0.08,
  disabledOpacity: 0.48,
};

const base = {
  primary,
  secondary,
  info,
  success,
  warning,
  error,
  grey,
  common,
  divider: alpha(grey[600], 0.2),
  action,
};

export function palette(mode) {
  const light = {
    ...base,
    mode: 'light',
    text: {
      primary: grey[900], // Improved for better readability
      secondary: grey[700],
      disabled: grey[500],
    },
    background: {
      paper: '#FFFFFF',
      default: '#FFFFFF',
      neutral: grey[200],
    },
    action: {
      ...base.action,
      active: grey[800],
    },
  };

  const dark = {
    ...base,
    mode: 'dark',
    text: {
      primary: '#FFFFFF',
      secondary: grey[400],
      disabled: grey[600],
    },
    background: {
      paper: grey[800],
      default: grey[900],
      neutral: alpha(grey[400], 0.12),
    },
    action: {
      ...base.action,
      active: grey[400],
    },
  };

  return mode === 'light' ? light : dark;
}
